import React from 'react';
import { usePageTracking } from '../../../hooks/usePageTracking';
import { GrowthModelProvider } from './GrowthModelProvider';
import GrowthModelView from './GrowthModelView';

const GrowthModelPage: React.FC = () => {
	usePageTracking('Page Viewed', 'Growth Model');
	return (
		<GrowthModelProvider>
			<GrowthModelView />
		</GrowthModelProvider>
	);
};

export default GrowthModelPage;
